import classNames from 'classnames'
import { convertDataToStringWithMonth } from 'helpers/date/convertDataToStringWithMonth'

import { TOfferPaymentStage } from '../OfferPriceBlock/useOfferPriceBlock'

import style from './OfferDatesBlock.module.scss'

type TOfferDatesBlock = {
  createdDate: string
  expireDate: string
  isOfferActive: boolean
  stage: TOfferPaymentStage
}

// информация о сроках действия КП

export const OfferDatesBlock = ({
  createdDate,
  expireDate,
  isOfferActive,
  stage,
}: TOfferDatesBlock) => {
  return (
    <>
      <span className={style.createdDate}>
        {`Коммерческое предложение от
                    ${convertDataToStringWithMonth(createdDate, true, false)}`}
      </span>
      {isOfferActive && (
        <span className={classNames('caption', style.dateEnd)}>
          {stage === 'AWAITING_FIRST_PAYMENT' &&
            `Срок оплаты первого платежа до ${convertDataToStringWithMonth(
              expireDate,
              false,
              true,
            )} включительно`}

          {stage === 'FULL' &&
            `Срок оплаты до ${convertDataToStringWithMonth(
              expireDate,
              false,
              true,
            )} включительно`}
        </span>
      )}

      {!isOfferActive &&
        (stage === 'FULL' || stage === 'AWAITING_FIRST_PAYMENT') && (
          <span className={classNames('caption', style.dateEnd)}>
            Срок действия коммерческого предложения истек. Для актуализации
            данных нажмите кнопку “Пересчитать”
          </span>
        )}
    </>
  )
}
